"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticPropContext = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
/**
 * This context should be used for things in Select and MultiSelect that don't expect to be changed during a
 * component's lifetime. This isn't a hard-n-fast rule, but this context can be a grab-bag of things we
 * want to propagate around these components. If some part of this context ends up changing frequently it
 * could hurt perf so we should break those things out if that becomes the case.
 */
const StaticPropContext = (0, _lodestarUtils.createContext)({}, "StaticPropContext");
exports.StaticPropContext = StaticPropContext;
//# sourceMappingURL=StaticPropContext.js.map